import { useQuery } from '@tanstack/react-query';
import { getFeaturedResourceItems } from '../api/resources.member.api';
import { resourcesKeys } from './resources.keys';

/**
 * The featured resource item for the member landing page.
 *
 * Returns a list (empty when nothing is featured) so the page keeps its
 * `find(isFeatured)` shape, but the API only ever sends the featured row —
 * the landing page stopped needing the full catalogue when the flat
 * "All Resources" grid was removed (fix F-1).
 *
 * Returns the raw query result — callers extract `data`, `isLoading`, `isError`.
 */
export function useResources() {
  return useQuery({
    queryKey: resourcesKeys.featuredItem(),
    queryFn: getFeaturedResourceItems,
  });
}
